import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import actions from 'actions'
import Player from 'components/Player/Player'
import v4 from 'uuid/v4'

class PlayerContainer extends Component {
  constructor () {
    super(...arguments)

    this.onPlayerLoaded = this.onPlayerLoaded.bind(this)
  }

  onPlayerLoaded (player) {
    const { metaUrl } = this.props.settings.mediaParams

    if (!metaUrl) {
      this.props.generateMetaForEdit({
        uniqueFunc: v4,
        data: [{
          dts: 0,
          meta: { action: 'cut-start' }
        }, {
          dts: parseInt(player.duration * 1000),
          meta: { action: 'cut-stop' }
        }],
        isLoaded: true
      })
    }
    this.props.setPlayerLoaded({
      isPlayerLoaded: true,
      playerElement: player
    })
  }

  render () {
    const { settings } = this.props

    return (
      <Player
        {...settings}
        onLoaded={this.onPlayerLoaded}
        setDts={this.props.setCurrentDts}
      />
    )
  }
}

const {
  object,
  func
} = PropTypes

PlayerContainer.propTypes = {
  settings: object.isRequired,
  setPlayerLoaded: func.isRequired,
  generateMetaForEdit: func.isRequired,
  setCurrentDts: func.isRequired
}

export default connect((state) => {
  return {
    settings: state.settings
  }
}, {
  setPlayerLoaded: actions.media.player.setPlayerLoaded,
  generateMetaForEdit: actions.media.generateMetaForEdit,
  setCurrentDts: actions.media.player.setCurrentDts
})(PlayerContainer)



// WEBPACK FOOTER //
// ./src/containers/PlayerContainer/PlayerContainer.js